<template>
	<div class="padding-x" :style="`padding-top: ${messageClose ? '0px' : '30px'}`">
		<order-message
			v-if="!messageClose"
			:action-code="actionCode"
			:success="!order.gatewayErrorCode && !order.gatewayAuthorizationResponse.data"
			@close-message="closeMessage"
		></order-message>
		<order-header
			:success="!order.gatewayErrorCode && !order.gatewayAuthorizationResponse.data"
			:full-name="order.customer.typePerson.fullName"
			:order="order"
		></order-header>
		<div class="order-row">
			<order-detail :products="order.details"></order-detail>
			<order-summary
				:amount="order.subtotal"
				:currency-symbol="getCurrencySymbol"
				:shipping-price="order.costShipping"
				:total="order.total"
			></order-summary>
		</div>
		<order-footer
			:account-name="accountName"
			:account-number="accountNumber"
			:billing="order.billing"
			:card-number="gatewayTransactionCardNumber"
			:customer="order.customer"
			:description="bankDescription"
			:dispatch-name="order.pickUpName"
			:flag-bill="!!order.flagBill"
			:logo-bank="logo"
			:payment-method="order.wayPayment.name"
			:warehouse-address="order.warehouseAddress"
			:gateway-transaction-id="gatewayTransactionId"
			:success="!order.gatewayErrorCode && !order.gatewayAuthorizationResponse.data"
		></order-footer>
		<order-actions
			:order-exist="orderExistValidate"
			:unpaid="order.paymentStateId === 1 || !!order.gatewayErrorCode"
			@see-detail="$router.push({ name: 'order-details', params: { id: order.id } })"
		></order-actions>
	</div>
</template>

<script>
	import orderActions from '@/components/order/order-actions';
	import orderDetail from '@/components/order/order-detail';
	import orderFooter from '@/components/order/order-footer';
	import orderHeader from '@/components/order/order-header';
	import orderMessage from '@/components/order/order-message';
	import orderSummary from '@/components/order/order-summary';
	import { mapGetters } from 'vuex';

	function created() {
		this.loadOrder();
	}

	async function loadOrder() {
		const headers = {
			Authorization: `Bearer ${this.token}`,
		};
		try {
			({ data: this.order } = await this.$httpJapi.get(
				`orders/${this.orderId}`,
				{ headers },
			));
			const gatewayResponse = this.order.gatewayAuthorizationResponse;
			this.accountName = this.order.bank ? this.order.bank.name : '';
			this.accountNumber = this.order.bank ? this.order.bank.number : '';
			this.bankDescription = this.order.bank ? this.order.bank.description : '';
			this.bankLogo = this.order.bank ? this.order.bank.urlImage : '';
			this.logo = !this.wayPayment ? '/static/img/icons/visanet-logo.jpg' : this.bankLogo;
			this.order.wayPayment = this.order.wayPayment || {};
			this.gatewayTransactionId = gatewayResponse && gatewayResponse.order ?
				gatewayResponse.order.transactionId : null;
			this.gatewayTransactionCardNumber = gatewayResponse && gatewayResponse.dataMap ?
				gatewayResponse.dataMap.CARD : gatewayResponse.data.CARD;
			this.actionCode = gatewayResponse && gatewayResponse.dataMap ?
				Number(gatewayResponse.dataMap.ACTION_CODE) : Number(gatewayResponse.data.ACTION_CODE);
			this.orderNotExist = !!gatewayResponse.data;
		} catch (err) {
			if (err.status === 400) {
				if (err.data.message === 'ORDER_NOT_FOUND') {
					this.orderNotExist = true;
					this.$message({
						message: 'Ocurrió un error al procesar el pago o el pedido no existe.',
						showClose: true,
						type: 'error',
					});
				}
			} else {
				this.$message({
					message: err.messageError,
					showClose: true,
					type: 'error',
				});
			}
		} finally {
			this.$store.commit('CLEAN_ORDER');
			this.$store.commit('UPDATE_PRODUCTS_SELECTED');
			this.$store.commit('UPDATE_RESPONSIBLE_VALID_DATA');
			this.$store.commit('SET_BILLING_DATA');
			this.$store.commit('UPDATE_DELIVERY_ADDRESS');
			this.$store.commit('SET_SHIPPING_COST', null);
			this.$store.commit('UPDATE_FLAG_PICK_UP');
		}
	}

	function closeMessage() {
		this.messageClose = true;
	}

	function orderExistValidate() {
		return !this.orderNotExist ||
			(!this.order.gatewayErrorCode && !this.order.gatewayAuthorizationResponse.data);
	}

	function data() {
		return {
			actionCode: null,
			accountName: '',
			accountNumber: '',
			bankDescription: '',
			bankLogo: '',
			gatewayTransactionId: null,
			gatewayTransactionCardNumber: null,
			logo: '',
			messageClose: false,
			order: {
				gatewayAuthorizationResponse: {},
				customer: {
					typePerson: {},
				},
				wayPayment: {},
			},
			orderNotExist: false,
		};
	}

	export default {
		name: 'order-created',
		components: {
			orderActions,
			orderDetail,
			orderFooter,
			orderHeader,
			orderMessage,
			orderSummary,
		},
		computed: {
			...mapGetters([
				'getCurrencySymbol',
				'token',
			]),
			orderExistValidate,
		},
		created,
		data,
		methods: {
			closeMessage,
			loadOrder,
		},
		props: {
			orderId: [Number, String],
		},
	};
</script>

<style lang="scss" scoped>
	.order-row {
		align-items: flex-start;
		display: flex;
	}

	.padding-x {
		padding-left: 5%;
		padding-right: 5%;
	}
</style>



// WEBPACK FOOTER //
// order-created.vue?1b272872